var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"toTopBtn",staticClass:"to-top-btn",on:{"click":function($event){return _vm.backTop()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }